import { Image, ImageBackground, View, Text } from "react-native";
import { useTranslation } from "react-i18next";

import { DayCount } from "./utils";
import Centered from "../../../../shared/Centered";
import {
  BGCurrentDayFrame,
  BGRegularDayFrame,
  BonusGamesModalDays,
  VipBadgeFramePng,
} from "../../../../assets";

export interface BGDayProps {
  day: DayCount;
  bonus: number;
  vipBonus?: number;
  currentDay?: DayCount;
  isVip?: boolean;
}

function BGDay({ day, bonus, vipBonus, currentDay, isVip }: BGDayProps) {
  const { t } = useTranslation();
  const isCurrent = currentDay != null && day === currentDay;
  const isFutureOrCurrent = currentDay !== undefined && day <= currentDay;
  const frameAspectRatio =
    isCurrent && isVip
      ? 1.22 // пробвай 1.18–1.28 според дизайна
      : isCurrent
        ? 1.18
        : 1.2;

  return (
    <View style={{ flex: isCurrent ? 1.1 : 1 }}>
      <View style={{ width: "100%" }}>
        {/* <Centered
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 10,
          }}
        > */}
        <ImageBackground
          source={isCurrent ? BGCurrentDayFrame : BGRegularDayFrame}
          style={{
            width: "100%",
            aspectRatio: isCurrent ? 1.119 : 1.088,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 10,
            paddingBottom: isVip ? 10 : 0, // ✅ гарантира място за VIP реда
          }}
          imageStyle={{
            resizeMode: "stretch", // или "contain" според как е рисуван frame PNG
          }}
        >
          <View>
            <Text
              style={{ fontWeight: "bold", color: "#fff", paddingBottom: 6 }}
            >
              {t("T_SITE_MODAL_BONUS_DAY")} {day}
            </Text>
          </View>
          <Image
            source={BonusGamesModalDays[day]}
            style={{
              height: "58%",
              aspectRatio: 1 / 1,
              opacity: isFutureOrCurrent ? 1 : 0.4,
              marginBottom: -18,
              marginRight: 2,
            }}
          />

          {/* <Centered
            style={{
              position: "absolute",
              left: 0,
              bottom: 20,
              right: 0,
              height: 1,
            }}
          > */}
          <Text
            style={{
              fontSize: 24,
              fontWeight: "bold",
              color: isFutureOrCurrent ? "#e9bf43" : "#d1d1d1",
              lineHeight: 26,
              marginBottom: 2,
            }}
          >
            {bonus}
          </Text>
          {/* </Centered> */}
          <View style={{ height: 16, justifyContent: "center" }}>
            {isVip ? (
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Image
                  source={VipBadgeFramePng}
                  style={{ width: 16, height: 16, marginRight: 4 }}
                />
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: isFutureOrCurrent ? "#e9bf43" : "#d1d1d1",
                    lineHeight: 16,
                  }}
                >
                  +{vipBonus}
                </Text>
              </View>
            ) : null}
          </View>
        </ImageBackground>

        {/* <ImageBackground
          source={currentDay === day ? BGCurrentDayFrame : BGRegularDayFrame}
          style={{
            width: "100%",
            aspectRatio: frameAspectRatio,
            position: "relative",
          }}
        /> */}
      </View>
    </View>
  );
}

export default BGDay;
